import { useBehavior } from '@libs/core';
import { TCommonData, TWidgetProps } from '@libs/types';
import React from 'react';
import { TFloatingLayoutOption } from '../../types/options';
import { FloatingLayoutView } from './FloatingLayoutView';

/**
 * Standalone floating layout widget driven entirely by server-provided configuration.
 * Owns behavior hooks (useBehavior) and delegates rendering to FloatingLayoutView.
 *
 * Use this component when the widget definition comes from the server and no
 * additional style overrides are required.
 */
const FloatingLayoutWidget = ({ widget, children }: React.PropsWithChildren<TWidgetProps<TCommonData, TFloatingLayoutOption>>) => {
    const { isHidden } = useBehavior(widget);

    return (
        <FloatingLayoutView
            uid={widget.uid}
            isHide={isHidden}
            margin={widget.options?.margin}
            alignment={widget.options?.alignment}
            styleName={widget.options?.style}
        >
            {children}
        </FloatingLayoutView>
    );
};

export { FloatingLayoutWidget };
